import React from 'react'

function DeepAnalysis() {
  return (
    <div>
       <iframe src="https://mukeshkumarbagaria.github.io/sih-deepAnalysis/"  height={800} width={1200}></iframe>

    </div>
  )
}

export default DeepAnalysis